import { DocumentReceiptEntity } from '../../../generated-api';
import { FormResult } from './types';

export function formDataToEntity(data: FormResult): DocumentReceiptEntity {
  const rowIds = data.rowIndices.map((row) => Object.keys(row)[0]);
  const receiptDetails = rowIds.map((rowId) => data.receipt_detail[rowId]);

  // payee となっているが実際には支払先ではなく摘要を表す
  const payee = data.payee ? [...data.payee] : [];
  if (data.payee_input) {
    payee.unshift(data.payee_input);
  }

  return {
    payment_date: data.payment_date,
    payee: [...new Set(payee)],
    business_number: data.business_number,
    receipt_details: receiptDetails,
    type: 'receipt',
  };
}
